import { Checkbox } from '@fox/atoms/src/checkbox';
import { FormRenderMode, QuestionStyleTypes } from '../../../../../form-runtime-context/contracts';
import { useFormRuntimeContext, useQuestionStyle } from '../../../../../form-runtime-context/form-runtime-context';
import { DataTableCustomFieldComponentArgs } from '../helpers';

export const CheckboxCustomField = ({ questionId, field, row, handleChange }: DataTableCustomFieldComponentArgs) => {
	const { formRenderMode } = useFormRuntimeContext();

	const val = row?.[field.fieldId] === '1';

	const { fontSize, fontFamily, color, fontStyle, textDecoration, fontWeight } = useQuestionStyle(QuestionStyleTypes.answer, {}, questionId);

	return (
		<Checkbox
			checked={val}
			value={val}
			size="small"
			alignCenter
			onChange={e => {
				if (formRenderMode === FormRenderMode.design) return;

				handleChange(e.target.checked ? '1' : '0', row.rowId, field.fieldId);
			}}
			sx={{
				'.MuiInputBase-root': {
					color,
					fontSize,
					fontStyle,
					fontFamily,
					textDecoration,
					fontWeight
				},
				'input:focus, textarea': {
					border: '0',
					boxShadow: 'none'
				}
			}}
		/>
	);
};
